export const Z_LIST = {
  axisLabel: 7,
  waterMark: 7,
  selectedLine: 6,
  axis: 5,
  markLine: 4,
  graphic: 2,
  zeroLine: 1,
  splitLine: 0,
  lineSymbol: 50
};
